// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section id='customer-term-deposits-create-list' class="box">
  <dynamic-list
    columns="\$ctrl.columns"
    data="\$ctrl.termDeposits"
    sorting="\$ctrl.sorting"></dynamic-list>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/term-deposits/new-term-deposit/new-term-deposit-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;